/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptReferenceMeasurementDto,
  BeamShapingGroupDto,
  CopyTaskItemAreaDto,
  CreateOrUpdateTaskItemDto,
  DataTypeInfoDto,
  EnumerationEvaluationParameterDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100ForbiddenException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100NotFoundException,
  ErrorResponseOfPtw100SetupCombinationsException,
  ErrorResponseOfPtw100UnauthorizedException,
  ErrorResponseOfPtw100UnprocessableContentException,
  EvaluationParameterScopeDto,
  GetBeamShapingGroupDto,
  GetCombinationTableDto,
  GetMedicalSystemSetupTemplate,
  GetMedicalSystemsForTaskRequestDto,
  GetNumericEvaluationParameterTemplateDto,
  GetQaEquipmentSetupTemplateDto,
  GetQaRtSystemTemplateDto,
  GetTaskItemEvaluationScopeDto,
  MedicalSystemRtSystemDto,
  MedicalSystemSetupBaseDto,
  NumericEvaluationParameterTemplateDto,
  ODataPostProcessedResultsOfTaskItemDto,
  ParameterCombinationTableDto,
  QaRtSystemTemplateDto,
  TaskItemAreaDto,
  TaskItemDto,
  TaskItemQaEquipmentSetupDto,
  TaskItemReferenceMeasurementResultsDto,
  TypesScopeDto,
} from '../models/index';
import {
    AcceptReferenceMeasurementDtoFromJSON,
    AcceptReferenceMeasurementDtoToJSON,
    BeamShapingGroupDtoFromJSON,
    BeamShapingGroupDtoToJSON,
    CopyTaskItemAreaDtoFromJSON,
    CopyTaskItemAreaDtoToJSON,
    CreateOrUpdateTaskItemDtoFromJSON,
    CreateOrUpdateTaskItemDtoToJSON,
    DataTypeInfoDtoFromJSON,
    DataTypeInfoDtoToJSON,
    EnumerationEvaluationParameterDtoFromJSON,
    EnumerationEvaluationParameterDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100ForbiddenExceptionFromJSON,
    ErrorResponseOfPtw100ForbiddenExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100NotFoundExceptionFromJSON,
    ErrorResponseOfPtw100NotFoundExceptionToJSON,
    ErrorResponseOfPtw100SetupCombinationsExceptionFromJSON,
    ErrorResponseOfPtw100SetupCombinationsExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON,
    ErrorResponseOfPtw100UnprocessableContentExceptionToJSON,
    EvaluationParameterScopeDtoFromJSON,
    EvaluationParameterScopeDtoToJSON,
    GetBeamShapingGroupDtoFromJSON,
    GetBeamShapingGroupDtoToJSON,
    GetCombinationTableDtoFromJSON,
    GetCombinationTableDtoToJSON,
    GetMedicalSystemSetupTemplateFromJSON,
    GetMedicalSystemSetupTemplateToJSON,
    GetMedicalSystemsForTaskRequestDtoFromJSON,
    GetMedicalSystemsForTaskRequestDtoToJSON,
    GetNumericEvaluationParameterTemplateDtoFromJSON,
    GetNumericEvaluationParameterTemplateDtoToJSON,
    GetQaEquipmentSetupTemplateDtoFromJSON,
    GetQaEquipmentSetupTemplateDtoToJSON,
    GetQaRtSystemTemplateDtoFromJSON,
    GetQaRtSystemTemplateDtoToJSON,
    GetTaskItemEvaluationScopeDtoFromJSON,
    GetTaskItemEvaluationScopeDtoToJSON,
    MedicalSystemRtSystemDtoFromJSON,
    MedicalSystemRtSystemDtoToJSON,
    MedicalSystemSetupBaseDtoFromJSON,
    MedicalSystemSetupBaseDtoToJSON,
    NumericEvaluationParameterTemplateDtoFromJSON,
    NumericEvaluationParameterTemplateDtoToJSON,
    ODataPostProcessedResultsOfTaskItemDtoFromJSON,
    ODataPostProcessedResultsOfTaskItemDtoToJSON,
    ParameterCombinationTableDtoFromJSON,
    ParameterCombinationTableDtoToJSON,
    QaRtSystemTemplateDtoFromJSON,
    QaRtSystemTemplateDtoToJSON,
    TaskItemAreaDtoFromJSON,
    TaskItemAreaDtoToJSON,
    TaskItemDtoFromJSON,
    TaskItemDtoToJSON,
    TaskItemQaEquipmentSetupDtoFromJSON,
    TaskItemQaEquipmentSetupDtoToJSON,
    TaskItemReferenceMeasurementResultsDtoFromJSON,
    TaskItemReferenceMeasurementResultsDtoToJSON,
    TypesScopeDtoFromJSON,
    TypesScopeDtoToJSON,
} from '../models/index';

export interface CopyTaskItemAreaRequest {
    copyTaskItemAreaDto?: CopyTaskItemAreaDto;
}

export interface CreateTaskItemRequest {
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

export interface DeleteTaskItemRequest {
    id: string;
}

export interface GetDataTypeCatalogForManualTaskRequest {
    targetSystemId: string;
}

export interface GetEnumerationEvaluationParameterForManualTaskRequest {
    enumerationId: string;
}

export interface GetMedicalSystemSetupTemplateRequest {
    getMedicalSystemSetupTemplate?: GetMedicalSystemSetupTemplate;
}

export interface GetMedicalSystemTypesScopesRequest {
    renameNone: boolean;
}

export interface GetMedicalSystemsForTaskRequest {
    getMedicalSystemsForTaskRequestDto?: GetMedicalSystemsForTaskRequestDto;
}

export interface GetNumericEvaluationParameterTemplateForManualTaskRequest {
    getNumericEvaluationParameterTemplateDto?: GetNumericEvaluationParameterTemplateDto;
}

export interface GetSetupCombinationsRequest {
    getCombinationTableDto?: GetCombinationTableDto;
}

export interface GetTaskItemRequest {
    id: string;
}

export interface GetTaskItemBeamShapingTemplateRequest {
    getBeamShapingGroupDto?: GetBeamShapingGroupDto;
}

export interface GetTaskItemEvaluationScopesForBccRequest {
    getTaskItemEvaluationScopeDto?: GetTaskItemEvaluationScopeDto;
}

export interface GetTaskItemListRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetTaskItemQaEquipmentSetupTemplateRequest {
    getQaEquipmentSetupTemplateDto?: GetQaEquipmentSetupTemplateDto;
}

export interface GetTaskItemQaRtSystemTemplateRequest {
    getQaRtSystemTemplateDto?: GetQaRtSystemTemplateDto;
}

export interface GetTaskItemReferenceMeasurementResultsRequest {
    measurementId: string;
}

export interface TaskItemAcceptReferenceMeasurementRequest {
    acceptReferenceMeasurementDto?: AcceptReferenceMeasurementDto;
}

export interface UpdateTaskItemRequest {
    id: string;
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

export interface ValidateTaskItemRequest {
    createOrUpdateTaskItemDto?: CreateOrUpdateTaskItemDto;
}

/**
 * 
 */
export class TaskItemsApi extends runtime.BaseAPI {

    /**
     */
    async copyTaskItemAreaRaw(requestParameters: CopyTaskItemAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/copy-task-item-area`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CopyTaskItemAreaDtoToJSON(requestParameters['copyTaskItemAreaDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemAreaDtoFromJSON(jsonValue), "TaskItemAreaDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemAreaDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async copyTaskItemArea(requestParameters: CopyTaskItemAreaRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['copyTaskItemAreaRaw']>>, TaskItemAreaDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemAreaDto;

         const response = this.copyTaskItemAreaRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async createTaskItemRaw(requestParameters: CreateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters['createOrUpdateTaskItemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 201: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue), "TaskItemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async createTaskItem(requestParameters: CreateTaskItemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['createTaskItemRaw']>>, TaskItemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemDto;

         const response = this.createTaskItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async deleteTaskItemRaw(requestParameters: DeleteTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTaskItem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async deleteTaskItem(requestParameters: DeleteTaskItemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['deleteTaskItemRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.deleteTaskItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getDataTypeCatalogForManualTaskRaw(requestParameters: GetDataTypeCatalogForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['targetSystemId'] == null) {
            throw new runtime.RequiredError(
                'targetSystemId',
                'Required parameter "targetSystemId" was null or undefined when calling getDataTypeCatalogForManualTask().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/datatype-catalog/{targetSystemId}`.replace(`{${"targetSystemId"}}`, encodeURIComponent(String(requestParameters['targetSystemId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataTypeInfoDtoFromJSON), "DataTypeInfoDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DataTypeInfoDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getDataTypeCatalogForManualTask(requestParameters: GetDataTypeCatalogForManualTaskRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getDataTypeCatalogForManualTaskRaw']>>, Array<DataTypeInfoDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<DataTypeInfoDto>;

         const response = this.getDataTypeCatalogForManualTaskRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getEnumerationEvaluationParameterForManualTaskRaw(requestParameters: GetEnumerationEvaluationParameterForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['enumerationId'] == null) {
            throw new runtime.RequiredError(
                'enumerationId',
                'Required parameter "enumerationId" was null or undefined when calling getEnumerationEvaluationParameterForManualTask().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/enumeration-evaluation-parameter/{enumerationId}`.replace(`{${"enumerationId"}}`, encodeURIComponent(String(requestParameters['enumerationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationEvaluationParameterDtoFromJSON(jsonValue), "EnumerationEvaluationParameterDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnprocessableContentException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => EnumerationEvaluationParameterDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getEnumerationEvaluationParameterForManualTask(requestParameters: GetEnumerationEvaluationParameterForManualTaskRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getEnumerationEvaluationParameterForManualTaskRaw']>>, EnumerationEvaluationParameterDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = EnumerationEvaluationParameterDto;

         const response = this.getEnumerationEvaluationParameterForManualTaskRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getMedicalSystemSetupTemplateRaw(requestParameters: GetMedicalSystemSetupTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/template-medical-system-setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMedicalSystemSetupTemplateToJSON(requestParameters['getMedicalSystemSetupTemplate']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemSetupBaseDtoFromJSON(jsonValue), "MedicalSystemSetupBaseDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => MedicalSystemSetupBaseDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getMedicalSystemSetupTemplate(requestParameters: GetMedicalSystemSetupTemplateRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getMedicalSystemSetupTemplateRaw']>>, MedicalSystemSetupBaseDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = MedicalSystemSetupBaseDto;

         const response = this.getMedicalSystemSetupTemplateRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getMedicalSystemTypesScopesRaw(requestParameters: GetMedicalSystemTypesScopesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['renameNone'] == null) {
            throw new runtime.RequiredError(
                'renameNone',
                'Required parameter "renameNone" was null or undefined when calling getMedicalSystemTypesScopes().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/medical-system-scopes/{renameNone}`.replace(`{${"renameNone"}}`, encodeURIComponent(String(requestParameters['renameNone']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue), "TypesScopeDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getMedicalSystemTypesScopes(requestParameters: GetMedicalSystemTypesScopesRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getMedicalSystemTypesScopesRaw']>>, TypesScopeDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TypesScopeDto;

         const response = this.getMedicalSystemTypesScopesRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getMedicalSystemsForTaskRaw(requestParameters: GetMedicalSystemsForTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/medical-systems-for-task`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMedicalSystemsForTaskRequestDtoToJSON(requestParameters['getMedicalSystemsForTaskRequestDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalSystemRtSystemDtoFromJSON), "MedicalSystemRtSystemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MedicalSystemRtSystemDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getMedicalSystemsForTask(requestParameters: GetMedicalSystemsForTaskRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getMedicalSystemsForTaskRaw']>>, Array<MedicalSystemRtSystemDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<MedicalSystemRtSystemDto>;

         const response = this.getMedicalSystemsForTaskRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getNumericEvaluationParameterTemplateForManualTaskRaw(requestParameters: GetNumericEvaluationParameterTemplateForManualTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/numeric-evaluation-parameter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetNumericEvaluationParameterTemplateDtoToJSON(requestParameters['getNumericEvaluationParameterTemplateDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => NumericEvaluationParameterTemplateDtoFromJSON(jsonValue), "NumericEvaluationParameterTemplateDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnprocessableContentExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnprocessableContentException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => NumericEvaluationParameterTemplateDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getNumericEvaluationParameterTemplateForManualTask(requestParameters: GetNumericEvaluationParameterTemplateForManualTaskRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getNumericEvaluationParameterTemplateForManualTaskRaw']>>, NumericEvaluationParameterTemplateDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = NumericEvaluationParameterTemplateDto;

         const response = this.getNumericEvaluationParameterTemplateForManualTaskRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getQaEquipmentTypesScopeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/qa-equipment-scope`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue), "TypesScopeDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TypesScopeDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getQaEquipmentTypesScope(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getQaEquipmentTypesScopeRaw']>>, TypesScopeDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TypesScopeDto;

         const response = this.getQaEquipmentTypesScopeRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getSetupCombinationsRaw(requestParameters: GetSetupCombinationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/setup-combinations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetCombinationTableDtoToJSON(requestParameters['getCombinationTableDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ParameterCombinationTableDtoFromJSON(jsonValue), "ParameterCombinationTableDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
          case 422: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100SetupCombinationsExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100SetupCombinationsException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ParameterCombinationTableDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getSetupCombinations(requestParameters: GetSetupCombinationsRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getSetupCombinationsRaw']>>, ParameterCombinationTableDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ParameterCombinationTableDto;

         const response = this.getSetupCombinationsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemRaw(requestParameters: GetTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTaskItem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue), "TaskItemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItem(requestParameters: GetTaskItemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemRaw']>>, TaskItemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemDto;

         const response = this.getTaskItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemBeamShapingTemplateRaw(requestParameters: GetTaskItemBeamShapingTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/beam-shaping-template`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBeamShapingGroupDtoToJSON(requestParameters['getBeamShapingGroupDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => BeamShapingGroupDtoFromJSON(jsonValue), "BeamShapingGroupDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => BeamShapingGroupDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemBeamShapingTemplate(requestParameters: GetTaskItemBeamShapingTemplateRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemBeamShapingTemplateRaw']>>, BeamShapingGroupDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = BeamShapingGroupDto;

         const response = this.getTaskItemBeamShapingTemplateRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemEvaluationScopesForBccRaw(requestParameters: GetTaskItemEvaluationScopesForBccRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/evaluation-scopes-bcc`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetTaskItemEvaluationScopeDtoToJSON(requestParameters['getTaskItemEvaluationScopeDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						 return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EvaluationParameterScopeDtoFromJSON), "EvaluationParameterScopeDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EvaluationParameterScopeDtoFromJSON));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemEvaluationScopesForBcc(requestParameters: GetTaskItemEvaluationScopesForBccRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemEvaluationScopesForBccRaw']>>, Array<EvaluationParameterScopeDto>>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = Array<EvaluationParameterScopeDto>;

         const response = this.getTaskItemEvaluationScopesForBccRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemListRaw(requestParameters: GetTaskItemListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        if (requestParameters['$filter'] != null) {
            queryParameters['$filter'] = requestParameters['$filter'];
        }

        if (requestParameters['$search'] != null) {
            queryParameters['$search'] = requestParameters['$search'];
        }

        if (requestParameters['$top'] != null) {
            queryParameters['$top'] = requestParameters['$top'];
        }

        if (requestParameters['$skip'] != null) {
            queryParameters['$skip'] = requestParameters['$skip'];
        }

        if (requestParameters['$orderby'] != null) {
            queryParameters['$orderby'] = requestParameters['$orderby'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTaskItemDtoFromJSON(jsonValue), "ODataPostProcessedResultsOfTaskItemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfTaskItemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemList(requestParameters: GetTaskItemListRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemListRaw']>>, ODataPostProcessedResultsOfTaskItemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = ODataPostProcessedResultsOfTaskItemDto;

         const response = this.getTaskItemListRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemQaEquipmentSetupTemplateRaw(requestParameters: GetTaskItemQaEquipmentSetupTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/template-qa-equipment-setup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetQaEquipmentSetupTemplateDtoToJSON(requestParameters['getQaEquipmentSetupTemplateDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemQaEquipmentSetupDtoFromJSON(jsonValue), "TaskItemQaEquipmentSetupDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemQaEquipmentSetupDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemQaEquipmentSetupTemplate(requestParameters: GetTaskItemQaEquipmentSetupTemplateRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemQaEquipmentSetupTemplateRaw']>>, TaskItemQaEquipmentSetupDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemQaEquipmentSetupDto;

         const response = this.getTaskItemQaEquipmentSetupTemplateRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemQaRtSystemTemplateRaw(requestParameters: GetTaskItemQaRtSystemTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/template-qa-rt-systems`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetQaRtSystemTemplateDtoToJSON(requestParameters['getQaRtSystemTemplateDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => QaRtSystemTemplateDtoFromJSON(jsonValue), "QaRtSystemTemplateDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => QaRtSystemTemplateDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemQaRtSystemTemplate(requestParameters: GetTaskItemQaRtSystemTemplateRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemQaRtSystemTemplateRaw']>>, QaRtSystemTemplateDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = QaRtSystemTemplateDto;

         const response = this.getTaskItemQaRtSystemTemplateRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async getTaskItemReferenceMeasurementResultsRaw(requestParameters: GetTaskItemReferenceMeasurementResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['measurementId'] == null) {
            throw new runtime.RequiredError(
                'measurementId',
                'Required parameter "measurementId" was null or undefined when calling getTaskItemReferenceMeasurementResults().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/reference-measurement-results/{measurementId}`.replace(`{${"measurementId"}}`, encodeURIComponent(String(requestParameters['measurementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemReferenceMeasurementResultsDtoFromJSON(jsonValue), "TaskItemReferenceMeasurementResultsDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemReferenceMeasurementResultsDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async getTaskItemReferenceMeasurementResults(requestParameters: GetTaskItemReferenceMeasurementResultsRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['getTaskItemReferenceMeasurementResultsRaw']>>, TaskItemReferenceMeasurementResultsDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemReferenceMeasurementResultsDto;

         const response = this.getTaskItemReferenceMeasurementResultsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async taskItemAcceptReferenceMeasurementRaw(requestParameters: TaskItemAcceptReferenceMeasurementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/accept-reference-measurement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AcceptReferenceMeasurementDtoToJSON(requestParameters['acceptReferenceMeasurementDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async taskItemAcceptReferenceMeasurement(requestParameters: TaskItemAcceptReferenceMeasurementRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['taskItemAcceptReferenceMeasurementRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.taskItemAcceptReferenceMeasurementRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async updateTaskItemRaw(requestParameters: UpdateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTaskItem().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters['createOrUpdateTaskItemDto']),
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue), "TaskItemDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
          case 404: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100NotFoundExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100NotFoundException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TaskItemDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     */
     async updateTaskItem(requestParameters: UpdateTaskItemRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['updateTaskItemRaw']>>, TaskItemDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TaskItemDto;

         const response = this.updateTaskItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     */
    async validateTaskItemRaw(requestParameters: ValidateTaskItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/task-items/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateTaskItemDtoToJSON(requestParameters['createOrUpdateTaskItemDto']),
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100ForbiddenExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100ForbiddenException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     */
     async validateTaskItem(requestParameters: ValidateTaskItemRequest = {}, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<TaskItemsApi['validateTaskItemRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.validateTaskItemRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
